import { useActions } from 'shared/hooks';
import { postFeedback } from 'store/survey/actions';
import { SendFeedbackInformationData } from '../../../../api/surveys/types';

export const useSurveyActions = () =>
  useActions({
    postFeedback,
  });

export const useHandleSubmit = () => {
  const { postFeedback: postAction } = useSurveyActions();
  return (data: SendFeedbackInformationData) => {
    postAction(data);
  };
};
